import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ResultData } from '@app/core/_common/model';
import { AuthService } from '@app/core/auth';
import { environment } from '@app/env-service';

@Injectable({
  providedIn: 'root',
})
export class CommentService {
  url :string = environment.url;

  private readonly _record = new BehaviorSubject<ResultData>(<ResultData>{});
  public record$ = this._record.asObservable();

  public gettingRecords :boolean = false;

  private params :any = {
    per_page: 100,
    page: 1,
  };

  constructor(
    private http :HttpClient,
    private translate :TranslateService,
    public authSvc :AuthService,
  ) {}

  setParams(params :any) {
    this.params = params;
  }

  refreshList() {
    this._record.next(<ResultData>{});
    this.get(this.params);
  }

  get(params :any) {
    this.gettingRecords = true;

    return this.http
      .get(`${this.url}/comments`, { params: params })
      .subscribe((resp :ResultData) => {
        resp.data.forEach((row) => {
          row.created_at = new Date(row.created_at);
          row.placement = 0;
          if (row.team_login_id == this.authSvc.loginUser.login_id) {
            row.placement = 1;
          }
        });
        this.gettingRecords = false;
        resp.data = resp.data.slice().reverse();
        this._record.next(resp);
      });
  }

  postComment(data :FormData) :Observable<any> {
    return this.http.post(`${this.url}/comments`, data).pipe(
      tap((resp :any) => {
        const record = this._record.getValue();
        resp.record.created_at = new Date(resp.record.created_at);
        resp.record.placement = 1;
        record.data.push(resp.record);
        this._record.next(record);
      }),
    );
  }

  getAll(params :any) :Observable<any> {
    return this.http.get(`${this.url}/comments/all`, { params: params });
  }
}
